module.exports = __webpack_public_path__ + "static/media/brewing.dc7c05d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/beers/brewing.jpg
// module id = 591
// module chunks = 0